import NotFound from '../notFound';

export default [
  {
    path: '*',
    component: NotFound,
  },
];



/** WEBPACK FOOTER **
 ** ./src/app/modules/404/routes/index.js
 **/